import request from '@/utils/request'
import { BASE_API } from '@/api/baseUrl'

/**
 * 合同相关api
 * 合同区域接口
 * @param {*} params
 */
export function findCityArea(params) {
  return request({
    url: BASE_API() + '/cityArea/findAll',
    method: 'get',
    params
  })
}

/**
 * 合同相关api
 * 获取财年
 * @param {*} params
 */
export function findByYear(params) {
  return request({
   // url: BASE_API() + '/contractYear/findByYear',
    url: BASE_API() + '/ztcrmContract/findMonthsByFiscalYear',
    method: 'get',
    params
  })
}


/**
 * 合同相关api
 * 获取区域列表
 * @param {*} params
 */
export function findAllNoIPage(params) {
  return request({
    url: BASE_API() + '/contractArea/findAllNoIPage',
    method: 'get',
    params
  })
}

/**
 * 合同相关api
 * 获取产品列表
 * @param {*} params
 */
export function productFindAllNoIPage(params) {
  return request({
    url: BASE_API() + '/contractProduct/findAllNoIPage',
    method: 'get',
    params
  })
}

/**
 * 合同相关api
 * 删除合同附件
 * @param {*} params
 */
export function contractFileDelete(params) {
  return request({
    url: BASE_API() + '/contractFile/delete',
    method: 'get',
    params
  })
}

/**
 * 合同相关api
 * 获取附件上传列表
 * @param {*} params
 */
export function fileFindAllNoIPage(params) {
  return request({
    url: BASE_API() + '/contractFile/findAllNoIPage',
    method: 'get',
    params
  })
}

/**
 * 合同相关api
 * 新增合同
 * @param {*} params
 */
export function contractAdd(data) {
  return request({
    url: BASE_API() + '/contract/add',
    method: 'post',
    data
  })
}

/**
 * 合同相关api
 * 查询合同
 * @param {*} params
 */
export function contractFindById(params) {
  return request({
    url: BASE_API() + '/ztcrmContract/findById',
    method: 'get',
    params
  })
}

/**
 * 合同相关api
 * 查询合同列表
 * @param {*} params
 */
export function contractFindAll(data) {
  return request({
    url: BASE_API() + '/ztcrmContract/findAll',
    method: 'post',
    data
  })
}

/**
 * 合同相关api
 * 查询合同明细列表
 * @param {*} params
 */
export function FindAllContractDetail(data) {
  return request({
    url: BASE_API() + '/ztcrmContract/findAllContractDetail',
    method: 'post',
    data
  })
}

/**
 * 合同相关api
 * 导入EXCEL 保存分类分月信息
 * @param {*} params
 */
export function saveContractFlfy(data) {
  return request({
    url: BASE_API() + '/ztcrmContract/saveContractFlfy',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/contract.js